/*
*  AGP events
*  Fichier de gestion fonctionnalités communes
*/

window.$windowH;
window.$windowW;


export default class Common {

    constructor() {
        this.$windowH;
        this.$windowW;
        this.$documentW;
        this.$windowInnerWidth;
        this.$windowInnerHeight;
        this.$windowW_actual;
        this.getWINDOW();
    }

    // calcul de la taille écran
    getWINDOW() {
        window.$windowH = $(window).height();
        window.$windowW = $(window).width();
        this.$windowH = $(window).height();
        this.$windowInnerHeight = $(window).innerHeight();
        this.$windowW = $(window).width();
        this.$documentW = $(document).width();
        this.$windowInnerWidth = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        if (this.$windowW_actual != this.$windowW) {
            this.$windowW_actual = this.$windowW;
        }
        if (window.$windowW < 769) {
            window.mobileState = true;
        }
    };

    // retourne une chaîne de type string coupée
    trim(name, length) {
        return name.length > length ? name.substring(0, length) + " ..." : name;
    };
}


